import { EmbeddedDefaultPaymentMethod } from "../components/EmbeddedDefaultPaymentMethod";

export const RouteDefaultPaymentMethod = () => {
  return <EmbeddedDefaultPaymentMethod />;
};
